import { SagaIterator } from 'redux-saga';
import { fork, put, take } from 'redux-saga/effects';
import config from '@/server/config';
import request from '@/server/request';

// 定义常量
export const types = {
    CATEGORY_PRODUCT_CONFIRM: 'user/ui/CATEGORY_PRODUCT_CONFIRM',
    CATEGORY_PRODUCT_HIDE: 'user/ui/CATEGORY_PRODUCT_HIDE',
    CATEGORY_PRODUCT_SELECT: 'user/ui/CATEGORY_PRODUCT_SELECT',
    CATEGORY_PRODUCT_SHOW: 'user/ui/CATEGORY_PRODUCT_SHOW',
    CATEGORY_PRODUCT_TAB: 'user/ui/CATEGORY_PRODUCT_TAB',
    GET_CATEGORY_PRODUCT_START: 'user/ui/GET_CATEGORY_PRODUCT_START',
    GET_CATEGORY_PRODUCT_SUCCESS: 'user/ui/GET_CATEGORY_PRODUCT_SUCCESS'
}

let bindConfirmAction: any;
let bindHideAction: any;

// 定义地址action接口
export interface ICategoryProductAction {
    type: string;
    showData?: {
        onConfirm?(r: any): void;
        onHide?(): void;
        init?: any;
    }
    selectData?: {
        index: number;
        k: number;
    };
    tabData?: {
        index: number;
    };
    payload?: any;
}
// 定义地址状态接口
export interface ICategoryProductStoreState {
    lvList1: any[];
    lvList2: any[];
    lvList3: any[];
    lvIndex2: number, // 市索引
    lvIndex3: number, // 区索引
    lvIndex1: number, // 省索引
    tabIndex: number,
    visible: boolean;
}

// 定义各方法，以供组件内部调用
/**
 * [获取数据]
 * @return action类型 
 */
export const getData = (): ICategoryProductAction => {
    return {
        type: types.GET_CATEGORY_PRODUCT_START
    }
}
// 隐藏面板
export const hideAction = () => {
    return {
        type: types.CATEGORY_PRODUCT_HIDE
    }
}

//  切换
export const tabAction = (index: number) => {
    return {
        tabData: {
            index
        },
        type: types.CATEGORY_PRODUCT_TAB
    }
}

// 选择某一项
export const selectItem = (index: number, k: number) => {
    return {
        selectData: {
            index, k
        },
        type: types.CATEGORY_PRODUCT_SELECT
    }
}

/**
 * [导出reducer] 使用export default导出，Ducks模式规则
 * @param state 组件状态
 * @param action 组件本次提供的action
 * @return 组件状态
 */
const initialState: ICategoryProductStoreState = {
    lvList1: [],
    lvList2: [],
    lvList3: [],
    lvIndex2: -1, // 市索引
    lvIndex3: -1, // 区索引
    lvIndex1: -1, // 省索引
    tabIndex: 0,
    visible: false
};
export default (state: ICategoryProductStoreState = initialState, action: ICategoryProductAction): ICategoryProductStoreState => {
    switch(action.type) {
        case types.CATEGORY_PRODUCT_CONFIRM:
            return {
                ...state,
                visible: false
            }
        case types.CATEGORY_PRODUCT_SHOW:
            // 绑定确认处理函数
            if(action.showData && action.showData.onConfirm) {
                bindConfirmAction = action.showData.onConfirm;
            } else {
                bindConfirmAction = null;
            }
            // 绑定取消处理函数
            if(action.showData && action.showData.onHide) {
                bindHideAction = action.showData.onHide;
            } else {
                bindHideAction = null;
            }
            const initData = action.showData && action.showData.init ? action.showData.init : {};
            if(initData.lv1 && initData.lv1.product_id) {
                let [templvIndex1, templvIndex2, templvIndex3] = [-1, -1, -1];
                let tabIndex = -1;
                let list2: any[] = [];
                let list3: any[] = [];
                state.lvList1.map((v: any, k: number) => {
                    if(v.product_id === initData.lv1.product_id) {
                        templvIndex1 = k;
                        list2 = v.children || [];
                        tabIndex = 0;
                        list2.map((v1: any, k1: number) => {
                            if(v1.product_id === initData.lv2.product_id) {
                                templvIndex2 = k1;
                                list3 = v1.children || [];
                                tabIndex = 1;
                                list3.map((v2: any, k2: number) => {
                                    if(v2.product_id === initData.lv3.product_id) {
                                        templvIndex3 = k2;
                                        tabIndex = 2;
                                    }
                                });
                            }
                        });
                    }
                });
                return {
                    ...state,
                    lvIndex2: templvIndex2,
                    lvIndex3: templvIndex3,
                    lvIndex1: templvIndex1,
                    lvList2: list2,
                    lvList3: list3,
                    tabIndex,
                    visible: true
                }
            } else {
                return {
                    ...state,
                    lvIndex2: -1,
                    lvIndex3: -1,
                    lvIndex1: -1,
                    tabIndex: 0,
                    lvList2: [],
                    lvList3: [],
                    visible: true,
                }
            }
        case types.CATEGORY_PRODUCT_HIDE:
            if(bindHideAction) {
                bindHideAction();
            }
            return {
                ...state,
                visible: false
            }
        case types.CATEGORY_PRODUCT_SELECT:
            if (action.selectData) {
                if (action.selectData.index === 0) { 
                    const temp = {
                        ...state,
                        lvIndex1: action.selectData.k,
                        lvList2: state.lvList1[action.selectData.k].children,
                        lvList3: [],
                        tabIndex: 1
                    };
                    if (state.lvList1[action.selectData.k].children.length === 0) { 
                        temp.lvList2 = [];
                        temp.tabIndex = 0;
                        temp.visible = false;
                        if (bindConfirmAction) { 
                            bindConfirmAction({
                                lv1: state.lvList1[action.selectData.k],
                                lv2: {},
                                lv3: {}
                            });
                        }
                    }
                    return temp;
                } else if (action.selectData.index === 1) {
                    const temp = {
                        ...state,
                        lvIndex2: action.selectData.k,
                        lvList3: state.lvList2[action.selectData.k].children,
                        tabIndex: 2
                    }
                    // if (state.lvList2[action.selectData.k].children.length === 0) { 
                    temp.lvList3 = [];
                    temp.tabIndex = 1;
                    temp.visible = false;
                    if (bindConfirmAction) { 
                        bindConfirmAction({
                            lv1: state.lvList1[state.lvIndex1],
                            lv2: state.lvList2[action.selectData.k],
                            lv3: {}
                        });
                    }
                    // }
                    return temp;
                } else {
                    if(bindConfirmAction) {
                        bindConfirmAction({
                            lv1: state.lvList1[state.lvIndex1],
                            lv2: state.lvList2[state.lvIndex2],
                            lv3: state.lvList3[action.selectData.k],
                        });
                    }
                    return {
                        ...state,
                        lvIndex3: action.selectData.k,
                        visible: false
                    }
                }
            } else {
                return state;
            }
        case types.CATEGORY_PRODUCT_TAB:
            if(action.tabData) {
                if(action.tabData.index === 0) {
                    return {
                        ...state,
                        lvIndex1: -1,
                        lvIndex2: -1,
                        lvIndex3: -1,
                        tabIndex: action.tabData.index
                    }
                } else if(action.tabData.index === 1) {
                    return {
                        ...state,
                        lvIndex2: -1,
                        lvIndex3: -1,
                        tabIndex: action.tabData.index
                    }
                } else {
                    return {
                        ...state,
                        lvIndex3: -1,
                        tabIndex: action.tabData.index
                    }
                }
            } else {
                return state;
            }
        case types.GET_CATEGORY_PRODUCT_SUCCESS:
            const r = action.payload.data;
            if (r.error_code === 0 && r.data) {
                return {
                    ...state,
                    lvList1: r.data
                }
            } else {
                return state;
            }
        default:
            return state;
    }
}

// 定义saga
/**
 * 本页面使用，获取数据异步操作处理函数
 * @param action 组件提供action
 */
function* getListDataAsync( action: ICategoryProductAction ): any {
    const r = yield request({
        url: `${config.ULKAPI}api/web/index.php?r=second/search/product-class`,
        data: {
            filter: 0
        }
    });
    yield put({ type: types.GET_CATEGORY_PRODUCT_SUCCESS, payload: {
        data: r,
    } });
}

// 利用takeEvery检测未来可能会发生的行为，并且执行相应的操作
export function* watchProductCategoryDataAsync(): SagaIterator {
    // 写法1（可以连续接收到action）
    // yield takeEvery( types.RECEIVE_START, getListDataAsync );

    // 写法2（时间间隔过短无法连续接收到action，会有遗漏，可使用异步fork避免）
    while(true) {
        const action = yield take(types.GET_CATEGORY_PRODUCT_START);
        yield fork(getListDataAsync, action);
    }
}

